import React from "react";

interface ShowAllResultsButtonProps {
  onClick: () => void;
  text?: string;
  className?: string;
}

const ShowAllResultsButton: React.FC<ShowAllResultsButtonProps> = ({
  onClick,
  text = "Show all results",
  className = ""
}) => {
  return (
    <div className={`ViewAllResults tw-flex tw-items-center tw-justify-center ${className}`}>
      <button onClick={onClick} className="tw-text-search-grey tw-font-medium tw-underline">
        {text}
      </button>
    </div>
  );
};

export default ShowAllResultsButton;
